<template>
  <div>
    <list row-key="OtherReceivId" ref="list" unit="委外费用单" light-row @row-select="x => $emit('change', x)" :page="page"
      :query-params="params" :show-checkbox="showCheckbox" :show-query="showQuery" :get-data-func="api.list"
      :getColumn="tableColumns" :getParams="tableParams" :trendColumn="trendColumn" :trendParams="trendParams"
      v-if="trendShow">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <!-- <template slot="query">
        <el-form-item label="外协单位">
          <el-input v-model="params.DocNo" placeholder="请输入单据编号" clearable />s
          
          <outsourcer 后面补充 v-model="params.TradeUnitId" />
        </el-form-item>
        <el-form-item label="单据编号">
          <el-input v-model="params.DocNo" placeholder="请输入单据编号" clearable />
        </el-form-item>
        <el-form-item label="单据日期" v-if="!isMB">
          <range-picker
            :date="[params.DocDateStart, params.DocDateEnd]"
            @change="x=>{params.DocDateStart=x.Start;params.DocDateEnd=x.End;}"
          />
        </el-form-item>
        <el-form-item label="单据日期" v-if="isMB">
          <el-date-picker
            v-model.trim="params.DocDateStart"
            type="date"
            value-format="yyyy-MM-dd"
            style="width: 178px"
            placeholder="选择开始时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="截止日期" v-if="isMB">
          <el-date-picker
            v-model.trim="params.DocDateEnd"
            type="date"
            value-format="yyyy-MM-dd"
            style="width: 178px"
            placeholder="选择结束时间"
          ></el-date-picker>
        </el-form-item>
      </template> -->
      <template slot="table">
        <!-- <el-table-column prop="DocNo" label="单据编号" min-width="110" />
        <el-table-column prop="DocDate" label="单据日期" min-width="100">
          <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
        </el-table-column>
        <el-table-column prop="TradeUnitName" label="外协单位" />
        <el-table-column prop="Amount" label="金额" /> -->
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import tableColumn from "@/data/finance/dealings/outsource/list.json";
import tableParam from "@/data/finance/dealings/outsource/query.json";
// import outsourcer from "@/components/production/ticketmanagement/outsourcer/select";

export default {
  mixins: [listMixin],
  components: {
    list,
    // outsourcer 
  },
  data() {
    return {
      api: require("@/api/rp/outPocCost").default,
      formApi: require("@/api/sy/formSetting").default,
      tableApi: require("@/api/sy/tableSetting").default,
      queryApi: require("@/api/sy/selectSetting").default,
      trendColumn: tableColumn.Data,
      trendParams: tableParam.Data,
      tableColumns: tableColumn.Data,
      tableParams: tableParam.Data,
      trendShow: true,
      params: {
        TradeUnitId: null,
        DocNo: "",
        DocDateStart: this.$commonJs.getToday(),
        DocDateEnd: this.$commonJs.getToday(),
      },
      isMB: this.$store.state.isMB,
    };
  },

  methods: {
    showTable() {
      let modeName = location.hash.split("/").slice(1).join("");
      this.tableApi
        .list({ type: modeName })
        .then((res) => {
          if (res.Data === null || res.Data.length === 0) {
            return (this.trendShow = true);
          }
          if (res.Code == 0) {
            const ShowField = res.Data.map((x) => x.ShowField);

            this.tableColumns.forEach((item) => {
              const DataItem = res.Data.filter(
                (x) => x.ShowField == item.tableName
              );

              if (ShowField.indexOf(item.tableName) !== -1) {
                item.col.width = DataItem[0].ShowWidth;
                item.props.align = DataItem[0].Alignment;
                item.props.tooltip = DataItem[0].IsHidden;
              }
              // item.props.show = true
              item.props.show =
                ShowField.indexOf(item.tableName) !== -1 ? true : false;
            });
            this.trendShow = true;
            return (this.tableColumns = this.tableColumns.filter(
              (x) => x.props.show == true
            ));
          }
        })
        .then((res) => {
          this.getData();
        });
    },

    //
    showParams() {
      let modeName = location.hash.split("/").slice(1).join("");
      this.queryApi.list({ type: modeName }).then((res) => {
        if (res.Data === null || res.Data.length === 0) return;
        if (res.Code == 0) {
          const ShowField = res.Data.map((x) => x.ShowField);
          this.tableParams.forEach((item) => {
            const DataItem = res.Data.filter((x) => x.ShowField == item.field);

            if (ShowField.indexOf(item.field) !== -1) {
              item.col.labelWidth = DataItem[0].TagsWidth;
              item.col.width = DataItem[0].ShowWidth;
            }
            // item.props.show = true
            item.props.show =
              ShowField.indexOf(item.field) !== -1 ? true : false;
          });
          return (this.tableParams = this.tableParams.filter(
            (x) => x.props.show == true
          ));
        }
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
  },
};
</script>